/**
 * Domain Switcher - Custom Element
 * Handles disclosure toggle for cross-domain language switching.
 * On localhost, stays on current origin with locale param for testing.
 * Documentation: /docs/customizations/domain-switcher/
 */
if (!customElements.get('domain-switcher')) {
  class DomainSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-domain-switcher-toggle]');
      this.list = this.querySelector('.disclosure-list');
      if (!this.toggle) return;

      this.toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const expanded = this.hasAttribute('open');
        if (expanded) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('click', (e) => {
        if (this.hasAttribute('open') && !this.contains(e.target)) {
          this.close();
        }
      });

      this.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') this.close();
      });

      // Enhance links with query params and hash at runtime
      this.querySelectorAll('a[data-domain-link]').forEach((link) => {
        link.addEventListener('click', (e) => {
          const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);

          if (isLocalhost) {
            // On localhost, switch market via Shopify's localization
            e.preventDefault();
            const targetLang = link.getAttribute('hreflang');
            const nlDomain = this.dataset.nlDomain;
            const deDomain = this.dataset.deDomain;
            const targetDomain = targetLang === 'de' ? deDomain : nlDomain;
            // Navigate to the target domain's actual URL (will leave localhost)
            // but append current path + params
            const url = new URL('https://' + targetDomain + window.location.pathname);
            url.search = window.location.search;
            url.hash = window.location.hash;
            window.location.href = url.toString();
          } else {
            // On production, enhance href with query params and hash
            const url = new URL(link.href);
            url.search = window.location.search;
            url.hash = window.location.hash;
            link.href = url.toString();
          }
        });
      });
    }

    open() {
      this.setAttribute('open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.focus();
    }
  }

  customElements.define('domain-switcher', DomainSwitcher);
}
